export enum PaymentTypes {
  Account = 'Account',
  Check = 'Check',
  Cash = 'Cash',
  Debit = 'Debit',
  'Credit Card' = 'Credit Card'
}
